"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _Text2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _Loading2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Loading"));
var _Heading2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Heading"));
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Box = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _Alert = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Alert"));
var _react = require("react");
var _reactIntl = require("react-intl");
var _Email = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Email"));
var _Edit = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Edit"));
var _Logo = _interopRequireDefault(require("../../../Logo"));
var _context = require("../../../../services/brand/context");
var _apiV = require("../../../../services/auth/apiV2");
var _context2 = require("../../../../services/log/context");
var _events = require("../../consts/events");
var _OTPForm = _interopRequireDefault(require("./OTPForm"));
var _errors = _interopRequireDefault(require("../../../../consts/errors"));
var _usePublishOtpResendCodeClicked = _interopRequireDefault(require("../../consts/events/business/usePublishOtpResendCodeClicked"));
var _usePublishOtpScreenDisplayed = _interopRequireDefault(require("../../consts/events/business/usePublishOtpScreenDisplayed"));
var _jsxRuntime = require("react/jsx-runtime");
var _Heading, _FormattedMessage, _FormattedMessage2, _Text, _Loading, _FormattedMessage3, _FormattedMessage4, _FormattedMessage5, _FormattedMessage6, _FormattedMessage7, _div;
const OneTimePassword = _ref => {
  let {
    email,
    onChangeScreen,
    screen,
    otpTransactionId,
    onSignInFulfilled,
    onOtpTransactionIdChange
  } = _ref;
  const [timer, setTimer] = (0, _react.useState)(60);
  const [error, setError] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [shownMessage, setShownMessage] = (0, _react.useState)(false);
  const [resetKey, setResetKey] = (0, _react.useState)(0);
  const brand = (0, _context.useBrand)();
  const intl = (0, _reactIntl.useIntl)();
  const {
    log
  } = (0, _context2.useLog)();
  const publishOtpResendCodeClicked = (0, _usePublishOtpResendCodeClicked.default)();
  const publishOtpScreenDisplayed = (0, _usePublishOtpScreenDisplayed.default)();
  (0, _react.useEffect)(() => {
    publishOtpScreenDisplayed("email_otp", "web", error !== null);
  }, [error, publishOtpScreenDisplayed]);
  (0, _react.useEffect)(() => {
    const timerId = setTimeout(() => setTimer(prev => Math.max(0, prev - 1)), 1000);
    return () => clearTimeout(timerId);
  }, [timer]);
  const handleResendCode = () => {
    publishOtpResendCodeClicked("email_otp");
    setLoading(true);
    (0, _apiV.userOTPRequest)({
      email: email,
      brand: brand === null || brand === void 0 ? void 0 : brand.id
    }).then(response => {
      onOtpTransactionIdChange(response.transaction_id);
      setTimer(60);
      setShownMessage(true);
      setLoading(false);
      setResetKey(prev => prev + 1);
      setTimeout(() => {
        setShownMessage(false);
      }, 2000);
    }).catch(error => {
      log(_events.LOGIN_STEP_FAILED, {
        operation: "otpResend",
        error
      });
      setError(_errors.default.general);
      setLoading(false);
    });
  };
  const handleEdit = () => {
    if (screen === "oneTimePasswordSignUp") {
      onChangeScreen("newIntroSignIn");
    } else {
      onChangeScreen("newIntroSignUp");
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex items-center flex-col pt-[32px]",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Logo.default, {
        id: brand === null || brand === void 0 ? void 0 : brand.id,
        title: brand === null || brand === void 0 ? void 0 : brand.name,
        redirectUrl: "",
        url: brand === null || brand === void 0 ? void 0 : brand.base_url
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ModalSection.default, {
      dataTest: "MagicLogin-OTP",
      children: [_Heading || (_Heading = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Heading2.default, {
        type: "title3",
        spaceAfter: "medium",
        align: "center",
        id: "magic-login-header",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.verify_modal.title"
        })
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        display: "flex",
        align: "center",
        direction: "column",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text2.default, {
          size: "large",
          spaceAfter: "small",
          align: "center",
          children: [screen === "oneTimePasswordSignUp" && (_FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.verify_modal.sign_up_subtitle"
          }))), screen === "oneTimePasswordSignIn" && (_FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.verify_modal.sign_in_subtitle"
          })))]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          type: "primarySubtle",
          iconRight: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Edit.default, {
            ariaLabel: intl.formatMessage({
              id: "account_v2.components.edit"
            })
          }),
          spaceAfter: "large",
          onClick: handleEdit,
          children: email
        }), _Text || (_Text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
          spaceAfter: "large",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.verify_modal.enter_passcode"
          })
        }))]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OTPForm.default, {
        otpTransactionId: otpTransactionId,
        onSignInFulfilled: onSignInFulfilled
      }, resetKey), error != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
        dataTest: "MagicLogin-ErrorAlert",
        type: "critical",
        icon: true,
        labelClose: intl.formatMessage({
          id: "orbit.button_close"
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          ...error
        })
      }), loading ? _Loading || (_Loading = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading2.default, {
        type: "boxLoader"
      })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        display: "flex",
        justify: "center",
        align: "center",
        height: "44px",
        children: timer > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text2.default, {
          type: "secondary",
          children: [_FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.verify_modal.resend_code"
          })), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedRelativeTime, {
            value: timer,
            unit: "second"
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
          compact: true,
          type: "secondary",
          underlined: true,
          onClick: handleResendCode,
          children: _FormattedMessage4 || (_FormattedMessage4 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.verify_modal.resend_code"
          }))
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        display: "flex",
        justify: "center",
        align: "center",
        children: [screen === "oneTimePasswordSignUp" && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
            as: "span",
            margin: {
              right: 4
            },
            children: _FormattedMessage5 || (_FormattedMessage5 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.common.has_account"
            }))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
            asComponent: "button",
            onClick: handleEdit,
            children: _FormattedMessage6 || (_FormattedMessage6 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.sign_in"
            }))
          })]
        }), screen === "oneTimePasswordSignIn" && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
            as: "span",
            margin: {
              right: 4
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.common.need_account",
              values: {
                brandName: "Kiwi.com"
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
            asComponent: "button",
            onClick: handleEdit,
            children: _FormattedMessage7 || (_FormattedMessage7 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "common.signup"
            }))
          })]
        })]
      }), shownMessage && (_div || (_div = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "absolute top-300 left-[15%] w-[70%] p-300 rounded-150 bg-ink-dark",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Email.default, {
          ariaHidden: true,
          size: "small",
          customColor: "white",
          className: "mr-xs"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
          type: "white",
          as: "span",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.verify_modal.new_code_sent"
          })
        })]
      })))]
    })]
  });
};
var _default = exports.default = OneTimePassword;